"use client";

import { c as _c } from "react/compiler-runtime";
import type { SocialPlatform } from "@repo/design-system/components/social-link";
import { SocialLink } from "@repo/design-system/components/social-link";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { getCurrentYear } from "@repo/design-system/utils/date-helpers";
import { useLanguage } from "~/translations/loader/use-language";
declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: UC_UI is third party
    UC_UI: any;
  }
}
export default function FooterEonSverige() {
  const $ = _c(31);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      social: "facebook",
      href: "https://www.facebook.com/eonsverige/"
    }, {
      social: "instagram",
      href: "https://www.instagram.com/eon_sverige/?hl=sv"
    }, {
      social: "youtube",
      href: "https://www.youtube.com/user/eonsverige"
    }, {
      social: "linkedin",
      href: "https://www.linkedin.com/company/eonsverige/"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const socials = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ul aria-label="Social media" className="flex items-center gap-2">{socials.map(_temp)}</ul>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.footer_imprint || $[3] !== t.footer_link_imprint) {
    t2 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_imprint}>{t.footer_imprint}</CustomLink></li>;
    $[2] = t.footer_imprint;
    $[3] = t.footer_link_imprint;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t.footer_privacyPolicy) {
    t3 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href="/privacy">{t.footer_privacyPolicy}</CustomLink></li>;
    $[5] = t.footer_privacyPolicy;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t.footer_link_termsOfUse || $[8] !== t.footer_termsOfUse) {
    t4 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_termsOfUse}>{t.footer_termsOfUse}</CustomLink></li>;
    $[7] = t.footer_link_termsOfUse;
    $[8] = t.footer_termsOfUse;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t.footer_contact || $[11] !== t.footer_link_contact) {
    t5 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_contact}>{t.footer_contact}</CustomLink></li>;
    $[10] = t.footer_contact;
    $[11] = t.footer_link_contact;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t.footer_PKI || $[14] !== t.footer_link_PKI) {
    t6 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_PKI}>{t.footer_PKI}</CustomLink></li>;
    $[13] = t.footer_PKI;
    $[14] = t.footer_link_PKI;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t.footer_privacySettings) {
    t7 = <li><button className="cursor-pointer hover:underline" onClick={_temp2} type="button">{t.footer_privacySettings}</button></li>;
    $[16] = t.footer_privacySettings;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div className="flex flex-col md:flex-row md:justify-between lg:gap-x-4">{t1}<ul className="mb-9 grid justify-start font-medium text-sm leading-6 md:flex md:w-[60%] md:justify-end lg:m-auto lg:flex-wrap lg:justify-start">{t2}{t3}{t4}{t5}{t6}{t7}</ul></div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p>{`© E.ON SE ${getCurrentYear()}`}</p>;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = `${t.client} Logo`;
  let t11;
  if ($[26] !== t10) {
    t11 = <div className="flex items-center justify-end gap-x-8 text-sm lg:gap-x-12 xl:gap-x-20">{t9}<CustomImage alt={t10} height={29} src="images/logo/logo_footer.svg" width={100} /></div>;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t8) {
    t12 = <footer className="outer-container py-6"><div className="inner-container flex flex-col justify-between lg:flex-row">{t8}{t11}</div></footer>;
    $[28] = t11;
    $[29] = t8;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}
function _temp2() {
  return window.UC_UI?.showSecondLayer();
}
function _temp(entry) {
  return <li key={entry.href}><SocialLink className="shadow-none grayscale" href={entry.href} social={entry.social} /></li>;
}